import { graphql } from 'gql';

export const uerContractConstructionTypesGql = graphql(`
    query uerContractConstructionTypes($contractId: Long!) {
        uerContractConstructionTypes(contractId: $contractId) {
            result
            message
            data {
                id
                name
                code
                shortName
                catalogId
                fullName
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimContractConstructionTypesGql = graphql(`
    query bimContractConstructionTypes($contractId: Long!) {
        bimContractConstructionTypes(contractId: $contractId) {
            result
            message
            data {
                id
                name
                shortName
                code
                catalogId
                fullName
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getOtherFormulaSourceObjectGql = graphql(`
    query catalogOtherCostVariableSelectionItems(
        $skip: Int
        $take: Int
        $methodology: ProjectMethodologyEnum!
        $globalOnly: Boolean!
    ) {
        catalogOtherCostVariableSelectionItems(
            skip: $skip
            take: $take
            methodology: $methodology
            globalOnly: $globalOnly
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                uniqueId
                name
                entityUniqueId
                entityName
                dataSourceId
                dataSourceName
                type
                otherTypeUniqueId
                isGlobal
            }
        }
    }
`);
